export const TabInitialState = {
  tabId: "1",
};

export interface tabType {
  tabId?: string;
}
